module.exports = __webpack_public_path__ + "static/img/3681_phase_function_Paper_PointsHejduk_Prediction.085026a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3681_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 9paq
// module chunks = 0